import React from 'react';
import { withRouter } from 'react-router-dom';
import { Hidden } from '@material-ui/core';
import PropTypes from 'prop-types';
import LicenseListMobile from './license-list-mobile';
import LicenseListDesktop from './license-list-desktop';

const LicenseList = ({
  licenses, showZone, workPlan, workPlanList, showIsControlCompleted,
}) => (
  <>
    <Hidden lgUp>
      <LicenseListMobile
        licenses={licenses}
        showZone={showZone}
        workPlan={workPlan}
        workPlanList={workPlanList}
        showIsControlCompleted={showIsControlCompleted}
      />
    </Hidden>
    <Hidden mdDown>
      <LicenseListDesktop
        licenses={licenses}
        showZone={showZone}
        workPlan={workPlan}
        workPlanList={workPlanList}
        showIsControlCompleted={showIsControlCompleted}
      />
    </Hidden>
  </>
);

LicenseList.defaultProps = {
  showZone: true,
  workPlan: null,
  workPlanList: [],
};

LicenseList.propTypes = {
  licenses: PropTypes.array.isRequired,
  showZone: PropTypes.bool,
  workPlan: PropTypes.object,
  workPlanList: PropTypes.array,
  showIsControlCompleted: PropTypes.bool.isRequired,
};

export default withRouter((LicenseList));
